// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do

export const environment = {
    production: false,

    //For Local
    // WebAPIUrl: 'http://192.168.1.36:8252/api/',
    // FileBasePath: 'http://192.168.1.36:8252/'

    //For Live
    // WebAPIUrl: 'http://accentvision-007-site5.ltempurl.com/api/',
    // FileBasePath:'http://accentvision-007-site5.ltempurl.com/'

    WebAPIUrl: 'https://in.toc360.com/api/',
    FileBasePath:'https://in.toc360.com/'

    // WebAPIUrl: 'http://shankhi-001-site5.otempurl.com/api/',
    // FileBasePath:'http://shankhi-001-site5.otempurl.com/'

    // WebAPIUrl: 'http://shankhi-001-site1.gtempurl.com/api/',


    //LocalHost

    // WebAPIUrl: 'https://localhost:44348/api/',
    // FileBasePath: 'https://localhost:44348/'

    //  WebAPIUrl: 'https://myyatra360-001-site1.otempurl.com/api/',
    //  FileBasePath:'https://myyatra360-001-site1.otempurl.com/'

    //LocalHost

    // WebAPIUrl: 'http://shankhi-001-site1.gtempurl.com/api/',
    // FileBasePath: 'http://shankhi-001-site1.gtempurl.com/'

    //MyYatra360
    // WebAPIUrl: 'http://207.244.248.33:8226/api/',

    // FileBasePath: 'http://207.244.248.33:8226/'

};
